import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || (window.location.origin.replace(/:\d+$/, ':3002') + '/api');

const SMILEYS = [
  { val: 1, emoji: '😞', label: 'Très insatisfait' },
  { val: 2, emoji: '😕', label: 'Insatisfait' },
  { val: 3, emoji: '😐', label: 'Moyen' },
  { val: 4, emoji: '🙂', label: 'Satisfait' },
  { val: 5, emoji: '😄', label: 'Très satisfait' },
];

function QuestionSmiley({ question, value, onChange }) {
  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <p style={{ fontWeight: 600, marginBottom: '0.8rem', color: '#1e293b', lineHeight: 1.4 }}>
        {question.texte}
      </p>
      {question.note && (
        <p style={{ fontSize: '0.75rem', color: '#94a3b8', fontStyle: 'italic', marginBottom: '0.5rem' }}>
          {question.note}
        </p>
      )}
      <div style={{ display: 'flex', justifyContent: 'space-around', gap: '0.4rem' }}>
        {SMILEYS.map(s => (
          <button key={s.val} onClick={() => onChange(s.val)} style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px',
            padding: '0.5rem 0.3rem', borderRadius: '10px', border: '2px solid',
            borderColor: value === s.val ? '#2563eb' : '#e2e8f0',
            background: value === s.val ? '#eff6ff' : '#f8fafc',
            cursor: 'pointer', flex: 1, transition: 'all 0.15s',
          }}>
            <span style={{ fontSize: '1.8rem' }}>{s.emoji}</span>
            <span style={{ fontSize: '0.58rem', color: value === s.val ? '#2563eb' : '#94a3b8', fontWeight: 600, textAlign: 'center' }}>
              {s.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}

function QuestionTexte({ question, value, onChange }) {
  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <p style={{ fontWeight: 600, marginBottom: '0.8rem', color: '#1e293b', lineHeight: 1.4 }}>
        {question.texte}
      </p>
      <textarea value={value || ''} onChange={e => onChange(e.target.value)} rows={4}
        style={{
          width: '100%', padding: '0.7rem', borderRadius: '8px',
          border: '2px solid #e2e8f0', fontSize: '0.95rem', resize: 'vertical',
          fontFamily: 'inherit', boxSizing: 'border-box',
        }}
        placeholder="Vos remarques et suggestions..." />
    </div>
  );
}

function QuestionChapitre({ question }) {
  return (
    <div style={{
      margin: '1.5rem 0 0.8rem', padding: '0.6rem 1rem',
      background: '#e0e7ff', borderLeft: '4px solid #6366f1',
      borderRadius: '0 8px 8px 0',
      fontWeight: 700, color: '#3730a3', fontSize: '0.95rem', lineHeight: 1.4,
    }}>
      {question.texte}
    </div>
  );
}

export default function SatisfactionPublic() {
  const { token } = useParams();
  const [etat, setEtat] = useState('chargement');
  const [info, setInfo] = useState(null);
  const [reponses, setReponses] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [commence, setCommence] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE}/satisfaction/q/${token}`)
      .then(r => r.json())
      .then(d => {
        if (d.statut === 'ok') { setInfo(d); setEtat('ok'); }
        else { setMessage(d.message || d.error || 'Erreur'); setEtat(d.statut || 'erreur'); }
      })
      .catch(() => { setMessage('Impossible de contacter le serveur.'); setEtat('erreur'); });
  }, [token]);

  function setReponse(qid, val) {
    setReponses(r => ({ ...r, [qid]: val }));
  }

  async function handleSubmit() {
    const questions = (info?.questionnaire?.questions || []).filter(q => q.type_reponse === 'smiley' && !q.optionnel);
    const manquantes = questions.filter(q => reponses[q.question_id] == null);
    if (manquantes.length > 0) {
      alert(`Merci de répondre à toutes les questions obligatoires (${manquantes.length} restante${manquantes.length > 1 ? 's' : ''}).`);
      return;
    }
    setSubmitting(true);
    try {
      const r = await fetch(`${API_BASE}/satisfaction/q/${token}/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reponses }),
      });
      const d = await r.json();
      if (d.ok) { setMessage(d.message); setEtat('soumis'); }
      else alert('Erreur : ' + (d.error || 'Inconnue'));
    } catch { alert('Erreur réseau.'); }
    finally { setSubmitting(false); }
  }

  const containerStyle = {
    minHeight: '100vh', background: '#f8fafc',
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    padding: '1.5rem 1rem',
  };
  const cardStyle = {
    background: '#fff', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.1)',
    padding: '1.5rem', width: '100%', maxWidth: '520px',
  };

  if (etat === 'chargement') return (
    <div style={containerStyle}><div style={cardStyle}>
      <div style={{ textAlign: 'center', color: '#64748b', padding: '2rem' }}>
        <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>⏳</div>Chargement...
      </div>
    </div></div>
  );

  if (etat === 'soumis') return (
    <div style={containerStyle}><div style={{ ...cardStyle, textAlign: 'center' }}>
      <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
      <h2 style={{ color: '#16a34a', marginBottom: '0.5rem' }}>Merci !</h2>
      <p style={{ color: '#475569' }}>{message}</p>
    </div></div>
  );

  if (etat === 'deja_utilise') return (
    <div style={containerStyle}><div style={{ ...cardStyle, textAlign: 'center' }}>
      <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
      <h2 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>Déjà soumis</h2>
      <p style={{ color: '#475569' }}>{message}</p>
    </div></div>
  );

  if (etat === 'erreur') return (
    <div style={containerStyle}><div style={{ ...cardStyle, textAlign: 'center' }}>
      <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>❌</div>
      <h2 style={{ color: '#dc2626', marginBottom: '0.5rem' }}>Erreur</h2>
      <p style={{ color: '#475569' }}>{message}</p>
    </div></div>
  );

  const questionnaire = info?.questionnaire;
  const questions = questionnaire?.questions || [];
  const titre = questionnaire?.titre || 'Questionnaire de satisfaction';

  if (!commence) return (
    <div style={containerStyle}><div style={cardStyle}>
      <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
        <div style={{ fontSize: '0.75rem', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '0.4rem' }}>
          Satisfaction formation
        </div>
        <h1 style={{ fontSize: '1.25rem', color: '#1e293b', fontWeight: 700, marginBottom: '0.5rem', lineHeight: 1.3 }}>
          {titre}
        </h1>
        {info.intitule_formation && (
          <div style={{ fontSize: '0.88rem', color: '#475569', marginBottom: '0.3rem', fontWeight: 600 }}>
            {info.intitule_formation}
          </div>
        )}
        {info.nom_destinataire && (
          <div style={{ fontSize: '0.82rem', color: '#94a3b8' }}>{info.nom_destinataire}</div>
        )}
      </div>

      {questionnaire?.description && (
        <div style={{
          background: '#f1f5f9', borderRadius: '10px', padding: '1rem',
          marginBottom: '1.5rem', color: '#334155', fontSize: '0.92rem',
          lineHeight: 1.6, borderLeft: '4px solid #2563eb',
        }}>
          {questionnaire.description}
        </div>
      )}

      <div style={{ fontSize: '0.82rem', color: '#94a3b8', textAlign: 'center', marginBottom: '1.2rem' }}>
        {questions.filter(q => q.type_reponse !== 'chapitre').length} questions · 2 minutes environ
      </div>

      <button onClick={() => setCommence(true)} style={{
        width: '100%', padding: '1rem', borderRadius: '12px',
        background: '#2563eb', color: '#fff', fontWeight: 700,
        fontSize: '1.05rem', border: 'none', cursor: 'pointer',
        boxShadow: '0 4px 14px rgba(37,99,235,0.35)',
      }}>
        Commencer
      </button>
    </div></div>
  );

  return (
    <div style={containerStyle}><div style={cardStyle}>
      <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
        <div style={{ fontSize: '0.75rem', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '0.3rem' }}>
          Questionnaire de satisfaction
        </div>
        <h1 style={{ fontSize: '1.15rem', color: '#1e293b', fontWeight: 700 }}>
          {info.intitule_formation || titre}
        </h1>
        <div style={{ fontSize: '0.72rem', color: '#dc2626', marginTop: '0.3rem' }}>
          <span style={{ color: '#dc2626' }}>*</span> champs obligatoires
        </div>
      </div>

      {questions.map(q => {
        const qid = q.question_id;
        const val = reponses[qid];
        if (q.type_reponse === 'chapitre') return <QuestionChapitre key={qid} question={q} />;
        if (q.type_reponse === 'texte')    return <QuestionTexte key={qid} question={q} value={val} onChange={v => setReponse(qid, v)} />;
        if (q.type_reponse === 'smiley')   return (
          <div key={qid}>
            {!q.optionnel && <div style={{ fontSize: '0.67rem', color: '#dc2626', marginBottom: '0.15rem', fontWeight: 600 }}>* obligatoire</div>}
            {q.optionnel && q.note && <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginBottom: '0.3rem', fontStyle: 'italic' }}>{q.note}</div>}
            <QuestionSmiley question={q} value={val} onChange={v => setReponse(qid, v)} />
          </div>
        );
        return null;
      })}

      <button onClick={handleSubmit} disabled={submitting} style={{
        width: '100%', padding: '1rem', borderRadius: '12px',
        background: submitting ? '#94a3b8' : '#2563eb',
        color: '#fff', fontWeight: 700, fontSize: '1rem',
        border: 'none', cursor: submitting ? 'not-allowed' : 'pointer',
        marginTop: '0.5rem',
      }}>
        {submitting ? 'Envoi en cours...' : 'Valider mes réponses'}
      </button>
    </div></div>
  );
}
